<div class="page-container">
	<div class="page-body-container">
		<div class="card h-full md:h-auto md:w-2/6">
			<div class="card-header-container">
				<h1 class="card-header">Bezahlung erfolgreich!</h1>
			</div>
			<p class="py-0!">Vielen Dank, Ihre Bezahlung ist erfolgreich bei uns eingegangen.</p>
		</div>
	</div>
</div>
